import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { trackPageView } from 'utils/ga';

const handleRouteChange = () => {
  trackPageView();
};

const PageViewTracking = ({ children }) => {
  const router = useRouter();

  useEffect(() => {
    trackPageView();

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return children;
};

export default PageViewTracking;
